type DebounceReturn<TArgs extends unknown[]> = (...args: TArgs) => () => void;
export default function debounce<TArgs extends unknown[]>(
  func: (...args: TArgs) => void,
  wait = 300,
  option = { leading: false, trailing: true },
): DebounceReturn<TArgs> {
  // in basic debounce, we kept only timerId
  // here, we will keep lastArgs too as we trailing function call with last arguments
  let timerId: null | NodeJS.Timeout;
  let lastArgs: TArgs | null = null;

  // if both leading and trailing are false then do nothing.
  if (!option.leading && !option.trailing) return () => () => null;

  return function debounced(this: unknown, ...args: TArgs) {
    // if timer is over and leading is true
    // then immediately call supplied function
    // else capture arguments in lastArgs
    if (!timerId && option.leading) {
      // eslint-disable-next-line
      func.apply(this, args);
    } else {
      lastArgs = args;
    }

    // clear timer so that next call is exactly after `wait` time
    clearTimeout(timerId as NodeJS.Timeout);

    timerId = setTimeout(() => {
      // invoke only if lastArgs is present and trailing is true
      // eslint-disable-next-line
      if (option.trailing && lastArgs) func.apply(this, lastArgs);

      // reset variables as they need to restart new life after calling this function
      lastArgs = null;
      timerId = null;
    }, wait);

    // Return a cancellation function on call. Has no effect on already fired functions
    return function cancel() {
      clearTimeout(timerId as NodeJS.Timeout);
      timerId = null;
      lastArgs = null;
    };
  };
}
